// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J-qw","field":"styles_field__zWLfu","fieldCol":"styles_fieldCol__1xsXk","diffCol":"styles_diffCol__n-BUB","diff":"styles_diff__3iHct"};